
import { useState, useCallback } from 'react';

export const useCopyToClipboard = (resetDelay: number = 2000) => {
  const [isCopied, setIsCopied] = useState(false);

  const copy = useCallback((text: string) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), resetDelay);
      })
      .catch(err => console.error('Failed to copy: ', err));
  }, [resetDelay]);

  return { isCopied, copy };
};